module.exports = __webpack_public_path__ + "static/starter-clients-9308409acc753cae0d47c9eff8e6eb12.png";